import React, { useEffect, useRef } from 'react'
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { useState } from 'react';
import { AiOutlineEye } from 'react-icons/ai';
import Loader from "react-loader-spinner";
import { useReactToPrint } from 'react-to-print';
import Swal from "sweetalert2";
import { DecryptED } from "../../DecryptJS/Decrypt";
import { downloadExcel } from 'react-export-table-to-excel';
import moment from 'moment';
const LessonPlanAdminHome = () => {

    const { sid, userid } = useParams();
    const tableRef = useRef(null);
    const storageKey = `admin_lessonplan_state_${sid}_${userid}`;

    const [teachers, setTeachers] = useState([]);
    const [classList, setClassList] = useState([]);
    const [lessonReport, setLessonReport] = useState([]);
    const [apiloader, setapiLoader] = useState(false);
    const [getDataLoading, setGetDataLoading] = useState(false);
    const [hasRestored, setHasRestored] = useState(false);
    const [selectedTeacherOption, setSelectedTeacherOption] = useState('default');
    const [selectedClassOption, setSelectedClassOption] = useState('default');

    const [newReport, setNewReport] = useState([]);
    let tableCounter ;

    const [formData, setFormData] = useState({ sid: DecryptED(sid), userId: DecryptED(userid), staff: [], div: [], startDate: "", endDate: "", pageSize: 15, page: 1 });

    function formatDate(timestamp) {
        const date = new Date(timestamp);
        const year = date.getFullYear();
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const day = ('0' + date.getDate()).slice(-2);
        return `${year}-${month}-${day}`;
    }

    const getAllTeachers = async () => {
        try {
            setGetDataLoading(true)
            const data = {
                "sid": DecryptED(sid),
                "userId": DecryptED(userid)
            }
            await axios({
                method: "POST",
                url: `${process.env.REACT_APP_BASE_URL}/api/admin/lessonPlan/teachers`,
                data,
                headers: {
                    Authorization: "#$laksdfnlknoea#$@$%^&%$",
                },
            })
                .then((response) => {
                    setGetDataLoading(false)
                    setTeachers(response.data)
                })
                .catch((error) => {
                    setGetDataLoading(false)
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: (error.response && error.response.data && error.response.data.message) || "Could not load teachers",
                        showConfirmButton: false,
                        timer: 5000,
                    });
                });
        } catch (error) {
            setGetDataLoading(false)
            Swal.fire({
                position: "center",
                icon: "error",
                title: (error.response && error.response.data && error.response.data.message) || "Could not load teachers",
                showConfirmButton: false,
                timer: 5000,
            });
        }
    }

    const getAllClasses = async () => {
        try {
            setGetDataLoading(true)
            const data = {
                "sid": DecryptED(sid),
                "userId": DecryptED(userid)
            }
            await axios({
                method: "POST",
                url: `${process.env.REACT_APP_BASE_URL}/api/admin/lessonPlan/class`,
                data,
                headers: {
                    Authorization: "#$laksdfnlknoea#$@$%^&%$",
                },
            })
                .then((response) => {
                    setClassList(response.data)
                    setGetDataLoading(false)
                })
                .catch((error) => {
                    setGetDataLoading(false)
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: (error.response && error.response.data && error.response.data.message) || "Could not load classes",
                        showConfirmButton: false,
                        timer: 5000,
                    });
                });
        } catch (error) {
            setGetDataLoading(false)
            Swal.fire({
                position: "center",
                icon: "error",
                title: (error.response && error.response.data && error.response.data.message) || "Could not load classes",
                showConfirmButton: false,
                timer: 5000,
            });
        }
    }

    const generatePdf = useReactToPrint({
        content: () => tableRef.current,
        documentTitle: "LessonReport",
        onAfterPrint: () =>
            Swal.fire({
                position: "center",
                icon: "success",
                title: "Print Success!",
                showConfirmButton: false,
                timer: 1500,
            }),
    })

    const selectTeacher = (e) => {
        setSelectedTeacherOption(e);
        if (e === "SELECT ALL") {
            setFormData({ ...formData, staff: teachers.map((t) => t.staff_id) });
        } else {
            setFormData({ ...formData, staff: [parseInt(e)] });
        }
    }
    const selectClass = (e) => {
        setSelectedClassOption(e);
        if (e === "SELECT ALL") {
            setFormData({ ...formData, div: classList.map((c) => c.classdiv_id) });
        } else {
            setFormData({ ...formData, div: [parseInt(e)] });
        }
    }

    useEffect(() => {
        getAllTeachers();
        getAllClasses();
    }, [])

    const fetchData = async () => {
        setapiLoader(true);
        try {
                if(formData.staff.length <= 0 || formData.div.length <= 0){
                    throw new Error("Select Teachers and Class")
                }
                await axios({
                    method: "POST",
                    url: `${process.env.REACT_APP_BASE_URL}/api/admin/lessonPlan/all/report`,
                    data: formData,
                    headers: {
                        Authorization: "#$laksdfnlknoea#$@$%^&%$",
                    },
                })
                .then((response)=>{
                    setLessonReport(response.data);
                    const updatedArray = response.data.data.map(item => {
                        return {
                          Teacher: item.Teacher,
                          created_date: item.created_date,
                          div_name: item.div_name,
                          subject: item.subject,
                          LessonName: item.LessonName
                        }
                      });
                    setNewReport(updatedArray)
                    setapiLoader(false);
                })
                .catch((error)=> {throw error});
            
        } catch (error) {
            Swal.fire({
                position: "center",
                icon: "error",
                title: typeof error === "string"
                    ? error
                    : (error.response && error.response.data && error.response.data.message) || error.message || "Something went wrong",
                showConfirmButton: false,
                timer: 5000,
            });
            setapiLoader(false);
        }
    };


    const submitForm = (e) => {
        if (e) e.preventDefault();
        fetchData();
    };

    const changePage = (pageNo) =>{
        setFormData({...formData, page: pageNo});  
    }
     useEffect(() => {
        if(formData.staff.length > 0 && formData.div.length >0){
            fetchData();
        }
     }, [formData.page]);

    
    function handleDownloadExcel() {
        downloadExcel({
          fileName: `Admin_LessonReport_${moment().format('DD-MM-YYYY, h:mm:ss a') }`,
          sheet: "react-export-table-to-excel",
          tablePayload: {
            header: ["Teacher Name", "Date", "Class", "Subject", "Lesson Name"],
            // accept two different data structures
            body: newReport,
          },
        });
      }

      useEffect(() => {
        let restored = false;
        try {
            const saved = sessionStorage.getItem(storageKey);
            if (saved) {
                const parsed = JSON.parse(saved);
                if (parsed.formData) setFormData(parsed.formData);
                if (parsed.lessonReport) setLessonReport(parsed.lessonReport);
                if (parsed.newReport) setNewReport(parsed.newReport);
                if (parsed.selectedTeacherOption) setSelectedTeacherOption(parsed.selectedTeacherOption);
                if (parsed.selectedClassOption) setSelectedClassOption(parsed.selectedClassOption);
                restored = true;
            }
        } catch (e) {
            console.error(e);
        }

        if (!restored) {
            const today = new Date();
            const numberOfDaysToAdd = -30;
            const date = today.setDate(today.getDate() + numberOfDaysToAdd);

            const today2 = new Date();
            const CurrentDate = today2.toISOString().split('T')[0];

            const defaultValue = new Date(date).toISOString().split('T')[0];

            setFormData((prev) => ({ ...prev, startDate: defaultValue, endDate: CurrentDate }));
        }

        setHasRestored(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [])

      useEffect(() => {
        if (!hasRestored) return;
        try {
            sessionStorage.setItem(storageKey, JSON.stringify({
                formData,
                lessonReport,
                newReport,
                selectedTeacherOption,
                selectedClassOption,
            }));
        } catch (e) {
            console.error(e);
        }
      }, [hasRestored, formData, lessonReport, newReport, selectedTeacherOption, selectedClassOption, storageKey])


    return (
        <div className='container-fluid' style={{ backgroundColor: '#f4f6fb', minHeight: '100vh', padding: '24px' }}>
            <div className='container'>
                <h3 className='mb-4' style={{ color: '#1f2937', fontWeight: 700 }}>Lesson Plan Reports</h3>
                <div className='card shadow-sm rounded p-4 mb-4 bg-white'>
                <form className='row' onSubmit={submitForm}>
                    <div className='col-md-6 col-lg-3 mb-3'>
                        <div className="form-group mb-0">
                            <label htmlFor="teacherSelect">Teacher</label>
                            <select className="form-control" id="teacherSelect" value={selectedTeacherOption} onChange={(e) => { selectTeacher(e.target.value) }}>
                                <option value="default">SELECT TEACHER</option>

                                {
                                    getDataLoading ? <option>Loading... Please Wait</option> :
                                        <>
                                            <option value={"SELECT ALL"} >SELECT ALL TEACHERS</option>
                                            {teachers.length > 0 ? teachers.map((teacher, index) => (
                                                <option key={index} value={teacher.staff_id}>{teacher.Teacher}</option>
                                            )) : <option>NO DATA FOUD</option>}
                                        </>
                                }

                            </select>
                        </div>
                    </div>
                    <div className='col-md-6 col-lg-3 mb-3'>
                        <div className="form-group mb-0">
                            <label htmlFor="classSelect">Class</label>
                            <select className="form-control" id="classSelect" value={selectedClassOption} onChange={(e) => { selectClass(e.target.value) }}>
                                <option value="default">SELECT CLASS</option>

                                {
                                    getDataLoading ? <option>Loading... Please Wait</option> :
                                        <>
                                            <option value={"SELECT ALL"}>SELECT ALL CLASSES</option>
                                            {classList.length ? classList.map((classes, index) => (
                                                <option key={index} value={classes.classdiv_id}>{classes.div_name}</option>
                                            )) : (<option>NO DATA FOUND</option>)}
                                        </>
                                }
                            </select>
                        </div>
                    </div>

                    <div className='col-md-6 col-lg-3 mb-3'>
                        <div className="form-group mb-0">
                            <label htmlFor='fromDate'>FROM</label>
                            <input type="date" id="fromDate" className="form-control" defaultValue={formData.startDate} onChange={(e) => setFormData({ ...formData, startDate: e.target.value })} />
                        </div>
                    </div>
                    <div className='col-md-6 col-lg-3 mb-3'>
                        <div className="form-group mb-0">
                            <label htmlFor='toDate'>TO</label>
                            <input type="date" id="toDate" className="form-control" defaultValue={formData.endDate} onChange={(e) => setFormData({ ...formData, endDate: e.target.value })} />
                        </div>
                    </div>
                    <div className='col-12 d-flex justify-content-center'>
                        <input type='submit' className='btn btn-primary mt-0' value={apiloader ? "Loading…" : "Submit"} disabled={apiloader || getDataLoading} />
                    </div>
                </form>
                </div>
                {apiloader ? (
                    <div className="TMLoader">
                        <Loader type="ThreeDots" color="#bd2f5e" height={80} width={80} />
                    </div>
                ) : (
                    <div className='card shadow-sm rounded p-3 bg-white'>
                        {lessonReport.TotalCount ?
                            <div
                                className='w-100 d-flex flex-column flex-md-row justify-content-md-between align-items-start align-items-md-center mb-3'
                                style={{ gap: '12px' }}
                            >
                                <div>Showing Data: {formData.startDate} <b className='text-bold'>TO</b> {formData.endDate}</div>
                                <div className='d-flex flex-wrap' style={{ gap: '8px' }}>
                                    <button type="button" className='btn btn-primary btn-sm m-0' disabled={apiloader} onClick={() => { generatePdf(); }}>Export to PDF</button>
                                    <button type="button" className='btn btn-primary btn-sm m-0' disabled={apiloader} onClick={()=>handleDownloadExcel()}>Export to Excel</button>
                                </div>
                            </div>
                            : null}
                    <div className='table-responsive' >
                        <table className="table table-hover" ref={tableRef}>
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col"><strong>Teacher Name</strong></th>
                                    <th scope="col"><strong>Date</strong></th>
                                    <th scope="col"><strong>Class</strong></th>
                                    <th scope="col"><strong>Subject</strong></th>
                                    <th scope="col"><strong>Lesson Name</strong></th>
                                    <th scope="col"><strong>Actions</strong></th>
                                </tr>
                            </thead>
                            <tbody>
                                {lessonReport.TotalCount > 0 ? lessonReport.data.map((reports, index) => {
                                     tableCounter = (formData.page - 1) * 15 + index + 1;
                                   return (
                                    <tr key={index}>
                                        <th scope="row">{tableCounter}</th>
                                        <td>{reports.Teacher}</td>
                                        <td>{formatDate(reports.created_date)}</td>
                                        <td>{reports.div_name}</td>
                                        <td>{reports.subject}</td>
                                        <td>{reports.LessonName}</td>
                                        <td>
                                            <Link
                                                to={`/admin/report/${sid}/${userid}/${reports.id}`}
                                                aria-label={`View lesson plan for ${reports.Teacher}`}
                                                style={{ color: '#1565c0', display: 'inline-flex' }}
                                            >
                                                <AiOutlineEye size={20} />
                                            </Link>
                                        </td>
                                    </tr>
                                )}) : <tr>
                                    <td colSpan={7} className='text-center'>NO DATA FOUND</td>
                                </tr>}
                            </tbody>
                            <tfoot>
                                <tr>
                                    {lessonReport.TotalCount > 0 ?
                                        <td colSpan={7}>
                                            <nav aria-label="Page navigation example">
                                                <ul className="pagination justify-content-end">
                                                    <li className={`page-item ${formData.page <= 1 ? 'disabled' : ''}`}>
                                                        <button type="button" className="page-link" disabled={formData.page <= 1} onClick={() => changePage(formData.page - 1)}>Previous page</button>
                                                    </li>
                                                    <li className="page-item">
                                                        <div className="page-link">showing <b className='font-weight-bold'>{tableCounter}</b> OUT OF <b className='font-weight-bold'>{lessonReport.TotalCount}</b></div>
                                                    </li>
                                                    <li className={`page-item ${tableCounter === lessonReport.TotalCount ? 'disabled' : ''}`}>
                                                        <button type="button" className="page-link" disabled={tableCounter === lessonReport.TotalCount} onClick={() => changePage(formData.page + 1)}>Next page</button>
                                                    </li>
                                                </ul>
                                            </nav>
                                        </td> : <td>{""}</td>
                                    }
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default LessonPlanAdminHome
